module.exports = __webpack_public_path__ + "static/media/img3.40d647c5.jpg";